import $ from 'jquery';

const $dynamic_list_items = $('.dynamic-list-item');

if($dynamic_list_items.length !== 0) {
    const $dynamic_content = $('.dynamic-content');
    
    $dynamic_list_items.on('click', (e) => {
        console.log('clicked')
        const $this = $(e.currentTarget);
        const $dataKey = $this.data('key');
        const $matchingContent = $dynamic_content.filter((index, element) => {
            return $(element).data('key') === $dataKey;
        });
    
        $dynamic_list_items.removeClass('active');
        $this.addClass('active');
        $dynamic_content.removeClass('active');
        $matchingContent.addClass('active');
    });
}


